/**
 * הגדרות הסביבה של האפליקציה. נקראות מ-import.meta.env (קובץ .env.local).
 * הגדרות חסרות מוצגות כמסך הסבר במקום קריסה שקטה.
 */

export interface FirebaseWebConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  appId: string;
  messagingSenderId: string;
}

export interface WebConfig {
  firebase: FirebaseWebConfig;
  apiBaseUrl: string;
  vapidKey: string | null;
}

export type WebConfigResult = { ok: true; config: WebConfig } | { ok: false; missing: string[] };

type RawEnv = Record<string, string | boolean | undefined>;

export function readWebConfig(env: RawEnv): WebConfigResult {
  const get = (k: string) => {
    const v = env[k];
    return typeof v === 'string' ? v.trim() : '';
  };
  const required = [
    'VITE_FIREBASE_API_KEY',
    'VITE_FIREBASE_AUTH_DOMAIN',
    'VITE_FIREBASE_PROJECT_ID',
    'VITE_FIREBASE_APP_ID',
    'VITE_FIREBASE_MESSAGING_SENDER_ID',
  ];
  const missing = required.filter((k) => !get(k));
  if (missing.length) return { ok: false, missing };

  return {
    ok: true,
    config: {
      firebase: {
        apiKey: get('VITE_FIREBASE_API_KEY'),
        authDomain: get('VITE_FIREBASE_AUTH_DOMAIN'),
        projectId: get('VITE_FIREBASE_PROJECT_ID'),
        appId: get('VITE_FIREBASE_APP_ID'),
        messagingSenderId: get('VITE_FIREBASE_MESSAGING_SENDER_ID'),
      },
      apiBaseUrl: get('VITE_API_BASE_URL').replace(/\/+$/, ''),
      vapidKey: get('VITE_FIREBASE_VAPID_KEY') || null,
    },
  };
}

export const webConfig = readWebConfig(import.meta.env as RawEnv);
